/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getGlobalAnnouncements } from '../fn/public/get-global-announcements';
import { GetGlobalAnnouncements$Params } from '../fn/public/get-global-announcements';
import { GetGlobalAnnouncementsResponse } from '../models/get-global-announcements-response';

@Injectable({ providedIn: 'root' })
export class PublicService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getGlobalAnnouncements()` */
  static readonly GetGlobalAnnouncementsPath = '/public/announcements';

  /**
   * Get all announcements.
   *
   * Get all announcements
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGlobalAnnouncements()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGlobalAnnouncements$Response(params?: GetGlobalAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGlobalAnnouncementsResponse>> {
    const obs = getGlobalAnnouncements(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all announcements.
   *
   * Get all announcements
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGlobalAnnouncements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGlobalAnnouncements(params?: GetGlobalAnnouncements$Params, context?: HttpContext): Observable<GetGlobalAnnouncementsResponse> {
    const resp = this.getGlobalAnnouncements$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetGlobalAnnouncementsResponse>): GetGlobalAnnouncementsResponse => r.body)
    );
  }

}
